import { useGetCustomFieldsBasedOnType } from "@portal/queries/custom-field-query";
import {
  CustomFieldColumData,
  CustomFieldDataResponse,
  CustomFieldRequestProps,
} from "@portal/types/entities/custom-field";
import { CustomFieldIconWithText, GrowFlex } from "@sinecycle/growcomponents";
import { Form, Skeleton } from "antd";
import { get, isEmpty, isNil, isString } from "lodash";
import { disputeFiledIds } from "@portal/types/entities/dispute";
import CustomFieldFormItems from "./CustomFieldEdit";
import { CustomFieldTypes } from "./type";
import { FormInstance } from "antd/lib";
import styled from "styled-components";

interface CustomFieldFormItemProps {
  customFields?: CustomFieldColumData[];
  form: FormInstance;
}

const StyledGrowFlex = styled(GrowFlex)`
  margin-bottom: var(--space-24);

  &:last-child {
    margin-bottom: 0;
  }
`;

function CustomFieldFormItem({
  customFields = [],
  form,
}: CustomFieldFormItemProps) {
  const { data: accountDisputeCustomFields = [], isLoading } =
    useGetCustomFieldsBasedOnType('DISPUTE', () => {}, true);

  if (isLoading) return <Skeleton.Input active style={{ width: "200px" }} />;

  // Initial value handled here — ONLY inside <Form.List>
  const initialMappedValues: CustomFieldRequestProps[] = customFields?.map(
    (f) => ({
      cf_id: f.cf_hash,
      value: get(f, "value", null),
      is_data_removed: false,
    })
  );

  const handleValueChange = (
    currentData: CustomFieldRequestProps[],
    index: number,
    field: CustomFieldDataResponse,
    value?: CustomFieldTypes
  ) => {
    const updated = [...currentData];
    const isEmptyValue = isNil(value) || (isString(value) && isEmpty(value));

    if (index === -1) {
      updated.push({
        cf_id: field.id,
        value,
        is_data_removed: isEmptyValue,
      });
    } else {
      updated[index] = {
        ...updated[index],
        value,
        is_data_removed: isEmptyValue,
      };
    }

    form.setFieldValue(disputeFiledIds.custom_field_data, updated);
  };

  return (
    <Form.List
      name={disputeFiledIds.custom_field_data}
      initialValue={initialMappedValues}
    >
      {(fields) => {
        const currentData: CustomFieldRequestProps[] =
          form.getFieldValue(disputeFiledIds.custom_field_data) || [];

        return (
          <>
            {accountDisputeCustomFields?.map((field) => {
              const index = currentData?.findIndex((f) => f.cf_id === field.id);
              const fieldValue = currentData[index]?.value;

              function handleClear() {
                handleValueChange(currentData, index, field, undefined);
              }
              return (
                <StyledGrowFlex
                  vertical
                  space="4"
                  key={field.id}
                >
                  <CustomFieldIconWithText>
                    {field.display_name}
                  </CustomFieldIconWithText>
                  <CustomFieldFormItems
                    customField={field}
                    value={fieldValue}
                    onChange={(value) =>
                      handleValueChange(currentData, index, field, value)
                    }
                    handleSelect={(value) =>
                      handleValueChange(currentData, index, field, value)
                    }
                    handleClear={handleClear}
                    handleClose={() => {}}
                    loading={false}
                    isFormItem={true}
                    handleSubmit={() => {}}
                    style={{ width: "100%", marginBottom: "var(--space-49)" }}
                    isEditable={field.editable}
                  />
                </StyledGrowFlex>
              );
            })}
          </>
        );
      }}
    </Form.List>
  );
}

export default CustomFieldFormItem;
